import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { VenueSalesItemSummary } from "src/app/shared/models/SalesSummary.model";

@Component({
	selector: "app-item-performance-view",
	templateUrl: "./item-performance-view.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class ItemPerformanceViewComponent implements OnInit, OnChanges {
	@Input() sortType: string;
	@Output() sortTypeChange = new EventEmitter<string>();

	@Input() itemSummary: VenueSalesItemSummary[];
	@Output() itemSummaryChange = new EventEmitter<VenueSalesItemSummary>();

	displaySummary1thru5: VenueSalesItemSummary[] = [];
	displaySummary6thru10: VenueSalesItemSummary[] = [];
	constructor() {}

	ngOnInit(): void {}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.sortType) {
			this.selectSortMethod(changes.sortType.currentValue);
		}
		if (changes.itemSummary) {
			this.selectSortMethod(this.sortType);
		}
	}

	selectSortMethod(sortType: string) {
		switch (sortType) {
			case "quantity": {
				this.sortByQuantity();
				break;
			}
			case "sales": {
				this.sortByRevenue();
				break;
			}
		}
	}

	sortByRevenue() {
		this.itemSummary.sort((a, b) => (a.revenue < b.revenue ? 1 : -1));
		this.displaySummary1thru5 = this.itemSummary.slice(0, 5);
		this.displaySummary6thru10 = this.itemSummary.slice(5, 10);
	}

	sortByQuantity() {
		this.itemSummary.sort((a, b) => (a.quantity < b.quantity ? 1 : -1));
		this.displaySummary1thru5 = [...this.itemSummary];
		this.displaySummary1thru5 = this.itemSummary.slice(0, 5);
		this.displaySummary6thru10 = this.itemSummary.slice(5, 10);
	}
}
